import { useMemo } from "react";
import { useSearchParams } from "react-router";

import { getSearchQuery } from "components/SearchInput/helpers";
import useTableSort from "components/Table/useTableSort";
import { SearchQueryOrderDirection } from "types/generated";

import { VcsAgentPoolView } from "../types";
import {
  SORT_CONFIG,
  VCS_AGENT_POOLS_COLUMN_ID,
  VCS_AGENT_POOLS_TABLE_FILTERS_STORAGE_KEY,
} from "./constants";
import { sortVcsAgentPools } from "./helpers";

export const useSortingVcsAgentPools = (vcsAgentPools: VcsAgentPoolView[] = []) => {
  const [searchParams] = useSearchParams();
  const searchInput = getSearchQuery(searchParams);

  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: VCS_AGENT_POOLS_TABLE_FILTERS_STORAGE_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: VCS_AGENT_POOLS_COLUMN_ID.NAME,
    initialSortDirection: SearchQueryOrderDirection.Asc,
  });

  const filteredVCSAgentPools = useMemo(() => {
    let filteredVCSAgentPools = [...vcsAgentPools];

    if (searchInput) {
      filteredVCSAgentPools = filteredVCSAgentPools.filter((vcsAgentPool) =>
        vcsAgentPool.name.toLowerCase().includes(searchInput.toLowerCase())
      );
    }

    if (sortDescriptor.column) {
      filteredVCSAgentPools = sortVcsAgentPools(filteredVCSAgentPools, sortDescriptor);
    }

    return filteredVCSAgentPools;
  }, [vcsAgentPools, searchInput, sortDescriptor]);

  return {
    filteredVCSAgentPools,
  };
};
